var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/link"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/link_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.418 12.2917H8.33464C7.99297 12.2917 7.70964 12.0083 7.70964 11.6667C7.70964 11.325 7.99297 11.0417 8.33464 11.0417H10.418C12.6013 11.0417 14.3763 9.26667 14.3763 7.08333C14.3763 4.9 12.6013 3.125 10.418 3.125H6.2513C4.06797 3.125 2.29297 4.9 2.29297 7.08333C2.29297 8 2.61797 8.89167 3.2013 9.6C3.41797 9.86667 3.38464 10.2583 3.11797 10.4833C2.8513 10.7 2.45964 10.6667 2.23464 10.4C1.46797 9.46667 1.04297 8.29167 1.04297 7.08333C1.04297 4.20833 3.3763 1.875 6.2513 1.875H10.418C13.293 1.875 15.6263 4.20833 15.6263 7.08333C15.6263 9.95833 13.293 12.2917 10.418 12.2917Z",
    fill: "#0F1653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.75 18.1249H9.58333C6.70833 18.1249 4.375 15.7916 4.375 12.9166C4.375 10.0416 6.70833 7.70825 9.58333 7.70825H11.6667C12.0083 7.70825 12.2917 7.99159 12.2917 8.33325C12.2917 8.67492 12.0083 8.95825 11.6667 8.95825H9.58333C7.4 8.95825 5.625 10.7333 5.625 12.9166C5.625 15.0999 7.4 16.8749 9.58333 16.8749H13.75C15.9333 16.8749 17.7083 15.0999 17.7083 12.9166C17.7083 11.9999 17.3833 11.1083 16.8 10.3999C16.5833 10.1333 16.6167 9.74159 16.8833 9.51659C17.15 9.29159 17.5417 9.33325 17.7667 9.59992C18.5417 10.5333 18.9667 11.7083 18.9667 12.9166C18.9583 15.7916 16.625 18.1249 13.75 18.1249Z",
    fill: "#0F1653"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.431e1d5c7417ebae34bcae5247fc1205.svg";
export { ForwardRef as ReactComponent };